/*
	This hook just bundles loading and unloading creative details when a component mounts and unmounts,
	so we don't forget to clear the data when we're done, which can cause bugs.

	Example usage:
	```
		function SpecificCreativeBlade(props){
			const { creativeId } = props;
			useCreativeDetail(creativeId);

			const creative = useSelector(state => state.creativeDetails);
			... // Do whatever with the data, don't worry about cleanup.
		}
	```
*/

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { loadCreative, clearDetails } from "reducers/CreativeDetails";

export default function useCreativeDetail(creativeId){
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(loadCreative(creativeId));

		return () => {
			dispatch(clearDetails());
		};
	}, []);
}
